import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/auth.js' 
import VueMeta from 'vue-meta'
import store from '@/store'
import companyAccount from '@/common/companyAccountTypes'
import moment from 'moment'

Vue.use(Router)
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
})

const router = new Router({
    mode: 'history',
    routes: [   
        {
            path: '*',
            name: 'notfoundpage',
            component: () => import(/* webpackChunkName: "NotFoundPage" */ '@/views/Public/NotFoundPage.vue'),
        },
        {
            path: '/notauthorized',
            name: 'NotAuthorizedPage',
            component: () => import(/* webpackChunkName: "NotAuthorizedPage" */ '@/views/Public/NotAuthorizedPage.vue'),
        },    
        {
            path: '/maintenance',
            name: 'SystemMaintenance',
            component: () => import(/* webpackChunkName: "SystemMaintenance" */ '@/views/Public/SystemMaintenance.vue'),
        },
        {
            path: '/home',
            name: 'SystemUpdatesCheck',
            component: () => import(/* webpackChunkName: "SystemUpdatesCheck" */ '@/views/Public/SystemUpdatesCheck.vue'),
        },
        {
            path: '/signin-options',
            name: 'LoginOptions',
            component: () => import(/* webpackChunkName: "LoginOptions" */ '@/views/Public/LoginOptions.vue'),
        },
        {
            path: '/signin-with-password',
            name: 'LoginWithPassword',
            component: () => import(/* webpackChunkName: "LoginWithPassword" */ '@/views/Public/LoginWithPassword.vue'),
        },
        {
            path: '/otp',
            name: 'OTPVerification',
            component: () => import(/* webpackChunkName: "OTPVerification" */ '@/views/Public/OTPVerification.vue'),
        },
        {
            path: '/changepassword',
            name: 'ChangePassword',
            component: () => import(/* webpackChunkName: "ChangePassword" */ '@/views/Public/ChangePassword.vue'),
        },
        {
            path: '/passwordrecovery',
            name: 'PasswordRecovery',
            component: () => import(/* webpackChunkName: "PasswordRecovery" */ '@/views/Public/PasswordRecovery.vue'),
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "Main" */ '@/views/Main.vue'),  
            children: [
                {
                    path: '/',
                    name: 'Dashboard',
                    component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/MyDashboard.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/notifications',
                    name: 'Notifications',
                    component: () => import(/* webpackChunkName: "Notifications" */ '@/views/Notifications.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/mysettings',
                    name: 'MySettings',
                    component: () => import(/* webpackChunkName: "Themes" */ '@/views/MySettingsNew.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/myprofile',
                    name: 'MyProfile',
                    component: () => import(/* webpackChunkName: "MyProfile" */ '@/views/HR/Profile.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/features',
                    name: 'Features',
                    component: () => import(/* webpackChunkName: "Features" */ '@/views/Features.vue'),
                    beforeEnter: requireAuth
                },

                //MyAttendance
                {
                    path: '/myattendance',
                    name: 'MyAttendance',
                    component: () => import(/* webpackChunkName: "MyAttendance" */ '@/views/MyAttendance/MyAttendance.vue'), 
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/daily',
                    name: 'MyAttendanceToday',
                    component: () => import(/* webpackChunkName: "MyAttendanceToday" */ '@/views/MyAttendance/MyAttendanceToday.vue'), 
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/daily/:transDate',
                    name: 'attendanceDaily',
                    component: () => import(/* webpackChunkName: "AttendanceDaily" */ '@/views/MyAttendance/MyAttendanceDaily.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/calendar',
                    name: 'MyCalendar',
                    component: () => import(/* webpackChunkName: "MyCalendar" */ '@/views/MyAttendance/MyCalendar.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/timesheet',
                    name: 'TimesheetMain',
                    component: () => import(/* webpackChunkName: "TimesheetMain" */ '@/views/MyAttendance/TimesheetMain.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/timesheet/:cutOffId/:userId',
                    name: 'TimesheetByUser',
                    component: () => import(/* webpackChunkName: "TimesheetByUser" */ '@/views/MyAttendance/TimesheetByUser.vue'),
                    beforeEnter: requireAuth
                },
                
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/myattendance/corrections/details/:attendanceCorrectionsId',
                    name: 'AttendanceCorrectionsDetail',
                    component: () => import(/* webpackChunkName: "AttendanceCorrectionsDetail" */ '@/views/MyAttendance/AttendanceCorrectionsDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/corrections/summary/:cutOffId',
                    name: 'AttendanceCorrectionsSummary',
                    component: () => import(/* webpackChunkName: "AttendanceCorrectionsSummary" */ '@/views/MyAttendance/AttendanceCorrectionsSummary.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/corrections',
                    name: 'AttendanceCorrectionsMain',
                    component: () => import(/* webpackChunkName: "AttendanceCorrectionsMain" */ '@/views/MyAttendance/AttendanceCorrectionsMain.vue'),
                    beforeEnter: requireAuth
                },
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/myattendance/timeoff/details/:timeOffId',
                    name: 'TimeOffDetail',
                    component: () => import(/* webpackChunkName: "TimeOffDetail" */ '@/views/MyAttendance/TimeOffDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/timeoff/summary/:cutOffId',
                    name: 'TimeOffSummary',
                    component: () => import(/* webpackChunkName: "TimeOffSummary" */ '@/views/MyAttendance/TimeOffSummary.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/timeoff',
                    name: 'TimeOffMain',
                    component: () => import(/* webpackChunkName: "TimeOffMain" */ '@/views/MyAttendance/TimeOffMain.vue'),
                    beforeEnter: requireAuth
                },
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/myattendance/overtime/details/:overtimeId',
                    name: 'OvertimeDetail',
                    component: () => import(/* webpackChunkName: "OvertimeDetail" */ '@/views/MyAttendance/OvertimeDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/overtime/summary/:cutOffId',
                    name: 'OvertimeSummary',
                    component: () => import(/* webpackChunkName: "OvertimeSummary" */ '@/views/MyAttendance/OvertimeSummary.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myattendance/overtime',
                    name: 'OvertimeMain',
                    component: () => import(/* webpackChunkName: "OvertimeMain" */ '@/views/MyAttendance/OvertimeMain.vue'),
                    beforeEnter: requireAuth
                },
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                
                {
                    path: '/myattendance/faceai',
                    name: 'FaceRecognitionActivation',
                    component: () => import(/* webpackChunkName: "FaceRecognitionActivation" */ '@/views/MyAttendance/FaceRecognitionActivation.vue'),
                    beforeEnter: requireAuth
                },

                //MyTeams
                {
                    path: '/myteam',
                    name: 'MyTeam',
                    component: () => import(/* webpackChunkName: "MyTeam" */ '@/views/Team/MyTeam.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/myteam/attendance',
                    name: 'TeamAttendance',
                    component: () => import(/* webpackChunkName: "TeamAttendance" */ '@/views/Team/TeamAttendance.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/myteam/attendance/:transDate',
                    name: 'TeamAttendance',
                    component: () => import(/* webpackChunkName: "TeamAttendance" */ '@/views/Team/TeamAttendance.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/myteam/attendance/weekly/:weekNo',
                    name: 'TeamAttendanceWeekly',
                    component: () => import(/* webpackChunkName: "TeamAttendance" */ '@/views/Team/TeamAttendanceWeekly.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/myteam/workshiftplan',
                    name: 'teamworkshiftplan',
                    component: () => import(/* webpackChunkName: "TeamWorkshiftPlan" */ '@/views/Team/TeamWorkshiftPlan.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myteam/workshiftplan/:fiscalYear/:weekNo',
                    name: 'teamworkshiftplandetails',
                    component: () => import(/* webpackChunkName: "TeamWorkshiftPlanDetails" */ '@/views/Team/TeamWorkshiftPlanDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myteam/calendar',
                    name: 'teamcalendar',
                    component: () => import(/* webpackChunkName: "TeamCalendar" */ '@/views/Team/TeamCalendar.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myteam/timesheet',
                    name: 'TeamTimesheetMain',
                    component: () => import(/* webpackChunkName: "TeamTimesheetMain" */ '@/views/Team/TeamTimesheetMain.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myteam/timesheet/:cutOffId/:userId',
                    name: 'TimesheetByUser',
                    component: () => import(/* webpackChunkName: "TimesheetByUser" */ '@/views/MyAttendance/TimesheetByUser.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myteam/timesheet/:cutOffId',
                    name: 'TeamTimesheetByCutOff',
                    component: () => import(/* webpackChunkName: "TeamTimesheetByCutOff" */ '@/views/Team/TeamTimesheetByCutOff.vue'),
                    beforeEnter: requireAuth
                },
                 
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    // 1. Specific static path goes FIRST
                    path: '/myteam/corrections/details/:attendanceCorrectionsId',
                    name: 'AttendanceCorrectionsDetail',
                    component: () => import(/* webpackChunkName: "AttendanceCorrectionsDetail" */ '@/views/MyAttendance/AttendanceCorrectionsDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    // 2. Generic dynamic path goes SECOND
                    path: '/myteam/corrections/summary/:cutOffId',
                    name: 'TeamAttendanceCorrectionsCutOff',
                    component: () => import(/* webpackChunkName: "TeamAttendanceCorrectionsCutOff" */ '@/views/Team/TeamAttendanceCorrectionsCutOff.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myteam/corrections',
                    name: 'TeamAttendanceCorrectionsMain',
                    component: () => import(/* webpackChunkName: "TeamAttendanceCorrectionsMain" */ '@/views/Team/TeamAttendanceCorrectionsMain.vue'),
                    beforeEnter: requireAuth
                }, 
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                
                {
                    path: '/myteam/timeoff',
                    name: 'TeamTimeOffMain',
                    component: () => import(/* webpackChunkName: "TeamTimeOffMain" */ '@/views/Team/TeamTimeOffMain.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/myteam/timeoff/balances',
                    name: 'TeamTimeOffBalances',
                    component: () => import(/* webpackChunkName: "TeamTimeOffBalances" */ '@/views/Team/TeamTimeOffBalances.vue'),
                    beforeEnter: requireAuth
                },
                {
                    // Path for viewing own ledger
                    path: '/myattendance/timeoff/myledger/:leaveTypeId/:fiscalYear/:proRated',
                    name: 'MyLeaveTransactionLedger',
                    component: () => import(/* webpackChunkName: "LeaveTransactionLedger" */ '@/views/MyAttendance/TimeOffTransactionLedger.vue'),
                    beforeEnter: requireAuth
                },
                {
                    // Path for managers viewing a specific employee's ledger
                    path: '/myteam/timeoff/ledger/:userId/:leaveTypeId/:fiscalYear/:proRated',
                    name: 'TeamEmployeeLeaveLedger',
                    component: () => import(/* webpackChunkName: "LeaveTransactionLedger" */ '@/views/MyAttendance/TimeOffTransactionLedger.vue'),
                    beforeEnter: requireAuth
                },

                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    // 1. Specific static path goes FIRST
                    path: '/myteam/timeoff/details/:timeOffId',
                    name: 'TimeOffDetail',
                    component: () => import(/* webpackChunkName: "TimeOffDetail" */ '@/views/MyAttendance/TimeOffDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    // 2. Generic dynamic path goes SECOND
                    path: '/myteam/timeoff/summary/:cutOffId',
                    name: 'TeamTimeOffCutOff',
                    component: () => import(/* webpackChunkName: "TeamTimeOffCutOff" */ '@/views/Team/TeamTimeOffCutOff.vue'),
                    beforeEnter: requireAuth
                }, 
                // ---------------------------------------------------------------------------------------------------------------------------------------------------

                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/myteam/overtime/details/:overtimeId',
                    name: 'OvertimeDetail',
                    component: () => import(/* webpackChunkName: "OvertimeDetail" */ '@/views/MyAttendance/OvertimeDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/myteam/overtime/summary/:cutOffId',
                    name: 'TeamOvertimeCutOff',
                    component: () => import(/* webpackChunkName: "TeamOvertimeCutOff" */ '@/views/Team/TeamOvertimeCutOff.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/myteam/overtime',
                    name: 'TeamOvertimeMain',
                    component: () => import(/* webpackChunkName: "TeamOvertimeMain" */ '@/views/Team/TeamOvertimeMain.vue'),
                    beforeEnter: requireAuth
                }, 
                // ---------------------------------------------------------------------------------------------------------------------------------------------------

                {
                    path: '/myteam/uploadattendance',
                    name: 'TeamAttendanceUpload',
                    component: () => import(/* webpackChunkName: "TeamAttendanceUpload" */ '@/views/Team/TeamAttendanceUpload.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/myteam/uploadattendance/:cutOffId',
                    name: 'TeamAttendanceUploadDetails',
                    component: () => import(/* webpackChunkName: "TeamAttendanceUploadDetails" */ '@/views/Team/TeamAttendanceUploadDetails.vue'),
                    beforeEnter: requireAuth
                }, 
                //End MyTeams

                //compensation and benefits
                {
                    path: '/compensation',
                    name: 'Compensation',
                    component: () => import(/* webpackChunkName: "Compensation" */ '@/views/Compensation/Compensation.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/compensation/paygrades',
                    name: 'PayGrades',
                    component: () => import(/* webpackChunkName: "PayGrades" */ '@/views/Compensation/PayGrades.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/compensation/paygrades/:id',
                    name: 'PayGradeDetails',
                    component: () => import(/* webpackChunkName: "PayGradeDetails" */ '@/views/Compensation/PayGradeDetails.vue'),
                    beforeEnter: requireAuth
                },   
                {
                    path: '/compensation/allocation',
                    name: 'CompensationMain',
                    component: () => import(/* webpackChunkName: "CompensationMain" */ '@/views/Compensation/CompensationMain.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/compensation/allocation/:fiscalPeriodId',
                    name: 'CompensationYear',
                    component: () => import(/* webpackChunkName: "CompensationYear" */ '@/views/Compensation/CompensationYear.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/compensation/allocation/:userId/salary-history',
                    name: 'SalaryAndPay',
                    component: () => import(/* webpackChunkName: "SalaryAndPay" */ '@/views/Compensation/SalaryAndPay.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/compensation/allocation/:userId/leave-benefits',
                    name: 'LeaveBenefitsDetails',
                    component: () => import(/* webpackChunkName: "LeaveBenefitsDetails" */ '@/views/Compensation/LeaveBenefitsDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/compensation/allocation/:userId/deminimis-benefits',
                    name: 'DeminimisBenefitsDetails',
                    component: () => import(/* webpackChunkName: "DeminimisBenefitsDetails" */ '@/views/Compensation/DeminimisBenefitsDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/compensation/allocation/:userId/fringe-benefits',
                    name: 'FringeBenefitsDetails',
                    component: () => import(/* webpackChunkName: "FringeBenefitsDetails" */ '@/views/Compensation/FringeBenefitsDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/compensation/allocation/:userId/other-benefits',
                    name: 'OtherBenefitsDetails',
                    component: () => import(/* webpackChunkName: "OtherBenefitsDetails" */ '@/views/Compensation/OtherBenefitsDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/compensation/allocation/:fiscalPeriodId/:userId',
                    name: 'CompensationUser',
                    component: () => import(/* webpackChunkName: "CompensationUser" */ '@/views/Compensation/CompensationUser.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/compensation/mycompensation',
                    name: 'MyCompensation',
                    component: () => import(/* webpackChunkName: "MyCompensation" */ '@/views/Compensation/MyCompensation.vue'),
                    beforeEnter: requireAuth
                },
                //end compensation and benefits

                //payroll
                {
                    path: '/payroll',
                    name: 'Payroll',
                    component: () => import(/* webpackChunkName: "Payroll" */ '@/views/Payroll/Payroll.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/payroll/generate',
                    name: 'PayrollGenerate',
                    component: () => import(/* webpackChunkName: "PayrollMain" */ '@/views/Payroll/PayrollMain.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/payroll/generate/:id',
                    name: 'PayrollDetails',
                    component: () => import(/* webpackChunkName: "PayrollDetails" */ '@/views/Payroll/PayrollDetails.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/payroll/generate/:id/:userId',
                    name: 'PayrollUser',
                    component: () => import(/* webpackChunkName: "PayrollUser" */ '@/views/Payroll/PayrollUser.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/payroll/mypayslip',
                    name: 'MyPayslip',
                    component: () => import(/* webpackChunkName: "MyPayslip" */ '@/views/Payroll/MyPayslip.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/payroll/adjustments',
                    name: 'AdjustmentsMain',
                    component: () => import(/* webpackChunkName: "AdjustmentsMain" */ '@/views/Payroll/AdjustmentsMain.vue'),
                    beforeEnter: requireAuth
                }, 

                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/payroll/adjustments/details/:manualAdjustmentId',
                    name: 'AdjustmentsDetails',
                    component: () => import(/* webpackChunkName: "AdjustmentsDetails" */ '@/views/Payroll/AdjustmentsDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/adjustments/summary/:cutOffId',
                    name: 'AdjustmentsCutOff',
                    component: () => import(/* webpackChunkName: "AdjustmentsCutOff" */ '@/views/Payroll/AdjustmentsCutOff.vue'),
                    beforeEnter: requireAuth
                }, 
                // ---------------------------------------------------------------------------------------------------------------------------------------------------

                {
                    path: '/payroll/annualization',
                    name: 'AnnualizationMain',
                    component: () => import(/* webpackChunkName: "AnnualizationMain" */ '@/views/Payroll/AnnualizationMain.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/annualization/:fiscalPeriodId',
                    name: 'AnnualizationYear',
                    component: () => import(/* webpackChunkName: "AnnualizationYear" */ '@/views/Payroll/AnnualizationYear.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/annualization/:fiscalPeriodId/:userId',
                    name: 'AnnualizationUser',
                    component: () => import(/* webpackChunkName: "AnnualizationUser" */ '@/views/Payroll/AnnualizationUser.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/sss',
                    name: 'SSSContributionMain',
                    component: () => import(/* webpackChunkName: "SSSContributionMain" */ '@/views/Payroll/SSSContributionMain.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/sss/:fiscalYear/:month',
                    name: 'SSSContributionDetails',
                    component: () => import(/* webpackChunkName: "SSSContributionDetails" */ '@/views/Payroll/SSSContributionDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/pagibig',
                    name: 'PagibigContributionMain',
                    component: () => import(/* webpackChunkName: "PagibigContributionMain" */ '@/views/Payroll/PagibigContributionMain.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/pagibig/:fiscalYear/:month',
                    name: 'PagibigContributionDetails',
                    component: () => import(/* webpackChunkName: "PagibigContributionDetails" */ '@/views/Payroll/PagibigContributionDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/philhealth',
                    name: 'PhilhealthContributionMain',
                    component: () => import(/* webpackChunkName: "PhilhealthContributionMain" */ '@/views/Payroll/PhilhealthContributionMain.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/philhealth/:fiscalYear/:month',
                    name: 'PhilhealthContributionDetails',
                    component: () => import(/* webpackChunkName: "PhilhealthContributionDetails" */ '@/views/Payroll/PhilhealthContributionDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/payroll/reftables',
                    name: 'ReferenceTables',
                    component: () => import(/* webpackChunkName: "ReferenceTables" */ '@/views/Payroll/ReferenceTables.vue'),
                    beforeEnter: requireAuth
                },
                //end payroll

                //finance
                {
                    path: '/finance',
                    name: 'Finance',
                    component: () => import(/* webpackChunkName: "Finance" */ '@/views/Finance/Finance.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/finance/loans',
                    name: 'Loans',
                    component: () => import(/* webpackChunkName: "Loans" */ '@/views/Finance/Loans.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/finance/loans/:loanId',
                    name: 'LoansDetails',
                    component: () => import(/* webpackChunkName: "LoansDetails" */ '@/views/Finance/LoansDetails.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/finance/loans/:loanId',
                    name: 'LoansDetails',
                    component: () => import(/* webpackChunkName: "LoansDetails" */ '@/views/Finance/LoansDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/finance/loans/schedule/:loanScheduleId',
                    name: 'LoansScheduleDetails',
                    component: () => import(/* webpackChunkName: "LoansScheduleDetails" */ '@/views/Finance/LoansScheduleDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/finance/myloans',
                    name: 'MyLoans',
                    component: () => import(/* webpackChunkName: "MyLoans" */ '@/views/Finance/MyLoans.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/finance/myloans/:loanId',
                    name: 'MyLoansDetails',
                    component: () => import(/* webpackChunkName: "MyLoansDetails" */ '@/views/Finance/MyLoansDetails.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/finance/myloans/schedule/:loanScheduleId',
                    name: 'MyLoansScheduleDetails',
                    component: () => import(/* webpackChunkName: "MyLoansScheduleDetails" */ '@/views/Finance/MyLoansScheduleDetails.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/finance/cashadvances',
                    name: 'CashAdvances',
                    component: () => import(/* webpackChunkName: "CashAdvances" */ '@/views/Finance/CashAdvances.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/finance/mycashadvances',
                    name: 'MyCashAdvances',
                    component: () => import(/* webpackChunkName: "MyCashAdvances" */ '@/views/Finance/MyCashAdvances.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/finance/mycashadvances/:cashAdvancesId',
                    name: 'MyCashAdvancesDetails',
                    component: () => import(/* webpackChunkName: "MyCashAdvancesDetails" */ '@/views/Finance/MyCashAdvancesDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/finance/cashadvances/:cashAdvancesId',
                    name: 'CashAdvancesDetails',
                    component: () => import(/* webpackChunkName: "CashAdvancesDetails" */ '@/views/Finance/CashAdvancesDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/finance/reimbursements',
                    name: 'Reimbursements',
                    component: () => import(/* webpackChunkName: "Reimbursements" */ '@/views/Finance/Reimbursements.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/finance/reimbursements/:reimbursementsId',
                    name: 'ReimbursementsDetails',
                    component: () => import(/* webpackChunkName: "ReimbursementsDetails" */ '@/views/Finance/ReimbursementsDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/finance/myreimbursements',
                    name: 'MyReimbursements',
                    component: () => import(/* webpackChunkName: "MyReimbursements" */ '@/views/Finance/MyReimbursements.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/finance/myreimbursements/:reimbursementsId',
                    name: 'MyReimbursementsDetails',
                    component: () => import(/* webpackChunkName: "MyReimbursementsDetails" */ '@/views/Finance/ReimbursementsDetails.vue'), //ReimbursementsDetails.vue is reused
                    beforeEnter: requireAuth
                },
                //end finance

                //company
                {
                    path: '/company',
                    name: 'Company',
                    component: () => import(/* webpackChunkName: "Finance" */ '@/views/Company/Company.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/company/account',
                    name: 'Account',
                    component: () => import(/* webpackChunkName: "Account" */ '@/views/Company/Account.vue'),
                    beforeEnter: requireAuth
                },   
                {
                    path: '/company/billing',
                    name: 'Billing',
                    component: () => import(/* webpackChunkName: "Billing" */ '@/views/Company/Billing/Billing.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/billing/:invoiceId',
                    name: 'BillingDetails',
                    component: () => import(/* webpackChunkName: "BillingDetails" */ '@/views/Company/Billing/BillingDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/teams',
                    name: 'Teams',
                    component: () => import(/* webpackChunkName: "Teams" */ '@/views/Company/Teams.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/company/timesheets',
                    name: 'AllTeamsTimesheetsMain',
                    component: () => import(/* webpackChunkName: "AllTeamsTimesheetsMain" */ '@/views/Company/AllTeamsTimesheetsMain.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/company/timesheets/:cutOffId',
                    name: 'AllTeamsTimesheetsDetails',
                    component: () => import(/* webpackChunkName: "AllTeamsTimesheetsDetails" */ '@/views/Company/AllTeamsTimesheetsDetails.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/company/timesheets/:cutOffId/:userId',
                    name: 'TimesheetByUser',
                    component: () => import(/* webpackChunkName: "TimesheetByUser" */ '@/views/MyAttendance/TimesheetByUser.vue'),
                    beforeEnter: requireAuth
                },
                
                {
                    path: '/company/attendance',
                    name: 'CompanyAttendance',
                    component: () => import(/* webpackChunkName: "CompanyAttendance" */ '@/views/Company/CompanyAttendance.vue'),
                    beforeEnter: requireAuth
                },
                
                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/company/corrections/details/:attendanceCorrectionsId',
                    name: 'AttendanceCorrectionsDetail',
                    component: () => import(/* webpackChunkName: "AttendanceCorrectionsDetail" */ '@/views/MyAttendance/AttendanceCorrectionsDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/corrections/summary/:cutOffId',
                    name: 'CompanyAttendanceCorrectionsCutOff',
                    component: () => import(/* webpackChunkName: "CompanyAttendanceCorrectionsCutOff" */ '@/views/Company/CompanyAttendanceCorrectionsCutOff.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/corrections',
                    name: 'CompanyAttendanceCorrectionsMain',
                    component: () => import(/* webpackChunkName: "CompanyAttendanceCorrectionsMain" */ '@/views/Company/CompanyAttendanceCorrectionsMain.vue'),
                    beforeEnter: requireAuth
                },  
                // ---------------------------------------------------------------------------------------------------------------------------------------------------

                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/company/timeoff/details/:timeOffId',
                    name: 'TimeOffDetail',
                    component: () => import(/* webpackChunkName: "TimeOffDetail" */ '@/views/MyAttendance/TimeOffDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/timeoff/summary/:cutOffId',
                    name: 'CompanyTimeOffCutOff',
                    component: () => import(/* webpackChunkName: "CompanyTimeOffCutOff" */ '@/views/Company/CompanyTimeOffCutOff.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/company/timeoff',
                    name: 'CompanyTimeOffMain',
                    component: () => import(/* webpackChunkName: "CompanyTimeOffMain" */ '@/views/Company/CompanyTimeOffMain.vue'),
                    beforeEnter: requireAuth
                },
                // ---------------------------------------------------------------------------------------------------------------------------------------------------

                // ---------------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/company/overtime/details/:overtimeId',
                    name: 'OvertimeDetail',
                    component: () => import(/* webpackChunkName: "OvertimeDetail" */ '@/views/MyAttendance/OvertimeDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/overtime/summary/:cutOffId',
                    name: 'CompanyOvertimeCutOff',
                    component: () => import(/* webpackChunkName: "CompanyOvertimeCutOff" */ '@/views/Company/CompanyOvertimeCutOff.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/company/overtime',
                    name: 'CompanyOvertimeMain',
                    component: () => import(/* webpackChunkName: "CompanyOvertimeMain" */ '@/views/Company/CompanyOvertimeMain.vue'),
                    beforeEnter: requireAuth
                }, 
                // ---------------------------------------------------------------------------------------------------------------------------------------------------

                {
                    path: '/company/announcements',
                    name: 'CompanyAnnouncements',
                    component: () => import(/* webpackChunkName: "CompanyAnnouncements" */ '@/views/Company/Announcements/CompanyAnnouncements.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/announcements/:companyAnnouncementId',
                    name: 'CompanyAnnouncementsDetails',
                    component: () => import(/* webpackChunkName: "CompanyAnnouncementsDetails" */ '@/views/Company/Announcements/CompanyAnnouncementsDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/link',
                    name: 'LinkedAccounts',
                    component: () => import(/* webpackChunkName: "LinkedAccounts" */ '@/views/Company/LinkedAccounts.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/company/link/:companyId',
                    name: 'LinkedAccountDetails',
                    component: () => import(/* webpackChunkName: "LinkedAccountDetails" */ '@/views/Company/LinkedAccountDetails.vue'),
                    beforeEnter: requireAuth
                },
                //end company

                //HR
                {
                    path: '/hr',
                    name: 'HR',
                    component: () => import(/* webpackChunkName: "HR" */ '@/views/HR/HR.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/hr/employees',
                    name: 'Employees',
                    component: () => import(/* webpackChunkName: "Employees" */ '@/views/HR/Employees.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/hr/employees/upload',
                    name: 'EmployeesUpload',
                    component: () => import(/* webpackChunkName: "EmployeesUpload" */ '@/views/HR/EmployeesUpload.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/hr/employees/:userId',
                    name: 'UserProfile',
                    component: () => import(/* webpackChunkName: "UserProfile" */ '@/views/HR/Profile.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/hr/201',
                    name: '201Files',
                    component: () => import(/* webpackChunkName: "201Files" */ '@/views/HR/Employees.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/hr/201/:userId/files',
                    name: '201Files',
                    component: () => import(/* webpackChunkName: "201Files" */ '@/views/HR/201Files.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/hr/my201files',
                    name: '201Files',
                    component: () => import(/* webpackChunkName: "201Files" */ '@/views/HR/201Files.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/hr/workdays',
                    name: 'workdays',
                    component: () => import(/* webpackChunkName: "WorkDays" */ '@/views/HR/WorkDays.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/hr/edocuments',
                    name: 'eDocuments',
                    component: () => import(/* webpackChunkName: "eDocuments" */ '@/views/HR/eDocuments.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/hr/edocuments/:documentId',
                    name: 'eDocumentDetails',
                    component: () => import(/* webpackChunkName: "eDocumentDetails" */ '@/views/HR/eDocumentDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/hr/myedocuments',
                    name: 'MyeDocuments',
                    component: () => import(/* webpackChunkName: "MyeDocuments" */ '@/views/HR/MyeDocuments.vue'),
                    beforeEnter: requireAuth
                },
                //end HR

                //settings
                {
                    path: '/settings',
                    name: 'Settings',
                    component: () => import(/* webpackChunkName: "Settings" */ '@/views/Settings/Settings.vue'),
                    beforeEnter: requireAuth
                },  
                
                {
                    path: '/settings/leavetypes',
                    name: 'LeaveTypes',
                    component: () => import(/* webpackChunkName: "LeaveTypes" */ '@/views/Settings/LeaveTypes.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/settings/permissions',
                    name: 'AccessPermissions',
                    component: () => import(/* webpackChunkName: "AccessPermissions" */ '@/views/Settings/AccessPermissions.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/settings/permissions/:userId',
                    name: 'AccessPermissionsDetail',
                    component: () => import(/* webpackChunkName: "AccessPermissionsDetail" */ '@/views/Settings/AccessPermissionsDetail.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/settings/holidays',
                    name: 'HolidaysMain',
                    component: () => import(/* webpackChunkName: "HolidaysMain" */ '@/views/Settings/HolidaysMain.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/settings/holidays/:fiscalPeriodId',
                    name: 'HolidayYear',
                    component: () => import(/* webpackChunkName: "HolidayYear" */ '@/views/Settings/HolidayYear.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/settings/holidays/:fiscalPeriodId/:holidayId',
                    name: 'HolidayDetails',
                    component: () => import(/* webpackChunkName: "HolidayDetails" */ '@/views/Settings/HolidayDetails.vue'),
                    beforeEnter: requireAuth
                }, 
                {
                    path: '/settings/calendarperiods',
                    name: 'CalendarPeriods',
                    component: () => import(/* webpackChunkName: "CalendarPeriods" */ '@/views/Settings/CalendarPeriods.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/settings/calendarperiods/:fiscalPeroidId',
                    name: 'CalendarPeriodDetail',
                    component: () => import(/* webpackChunkName: "CalendarPeriodDetail" */ '@/views/Settings/CalendarPeriodDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/settings/calendarperiods/:fiscalPeroidId/:cutoffId',
                    name: 'CutoffPeriodDetail',
                    component: () => import(/* webpackChunkName: "CutoffPeriodDetail" */ '@/views/Settings/CutoffPeriodDetail.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/settings/workshifts',
                    name: 'workshifts',
                    component: () => import(/* webpackChunkName: "yWorkShifts" */ '@/views/Settings/WorkShifts.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/settings/cutoff',
                    name: 'cutoff',
                    component: () => import(/* webpackChunkName: "Cutoff" */ '@/views/Settings/Cutoff.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/settings/faceai',
                    name: 'FaceAISettings',
                    component: () => import(/* webpackChunkName: "FaceAISettings" */ '@/views/Settings/FaceAISettings.vue'),
                    beforeEnter: requireAuth
                },  
                {
                    path: '/settings/faceai/:userId',
                    name: 'FaceAISettingsDetails',
                    component: () => import(/* webpackChunkName: "FaceAISettingsDetails" */ '@/views/Settings/FaceAISettingsDetails.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/settings/teamroles',
                    name: 'TeamRoles',
                    component: () => import(/* webpackChunkName: "TeamRoles" */ '@/views/Settings/TeamRoles.vue'),
                    beforeEnter: requireAuth
                },
                {
                    path: '/settings/teamroles/:teamRoleId',
                    name: 'TeamRoleDetails',
                    component: () => import(/* webpackChunkName: "TeamRoleDetails" */ '@/views/Settings/TeamRoleDetails.vue'),
                    beforeEnter: requireAuth
                },
                //end settings

                {
                    path: '/logout',
                    beforeEnter (to, from, next) {
                        auth.logout()
                        next('/home')
                    }
                }
            ]
        }   
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition; // Scroll to the saved position if navigating back
        } else {
            return { x: 0, y: 0 }; // Scroll to top
        }
    },
});

// ⚡ GLOBAL NAVIGATION GUARD
router.beforeEach((to, from, next) => {
  
    // 1. 🛡️ SYSTEM MAINTENANCE GUARD ROUTINES
    if (to.path === '/maintenance' || to.name === 'SystemMaintenance') {
        const cachedNotifications = localStorage.getItem('publicNotifications')

        if (cachedNotifications) {
            try {
                const notifications = JSON.parse(cachedNotifications)
                const maintenanceNotice = notifications.find(item => item.categoryName === 'System Maintenance')

                if (maintenanceNotice) {
                    const now = moment()
                    const cleanStartStr = maintenanceNotice.effectiveDate.replace(' ', 'T').split('+')[0] + '+08:00'
                    const cleanEndStr = maintenanceNotice.expirationDate.replace(' ', 'T').split('+')[0] + '+08:00'

                    const start = moment(cleanStartStr)
                    const end = moment(cleanEndStr)

                    // If current time is legitimately within the downtime period, allow access to render
                    if (now.isBetween(start, end, null, '[]')) {
                        return next()
                    }
                }
            } catch (e) {
                console.error('Error parsing notifications in router guard:', e)
            }
        }

        // If someone accessed /maintenance manually but no active notice is live, boot them to home
        return next('/home')
    }

    // 2. 📝 REGULAR NAVIGATION ROUTINES
    // Array of target public pages that require a preceding system check verification step
    const publicPages = [
        'LoginOptions', 
        'LoginWithPassword', 
        'OTPVerification', 
        'ChangePassword', 
        'PasswordRecovery'
    ]

    const isPublicTarget = publicPages.includes(to.name)

    // 💡 FIX: Use localStorage instead of localStorage for iOS PWA persistence
    const hasPassedSystemCheck = localStorage.getItem('sweldonow_system_checked') === 'true'

    // If trying to access a deep public link without checking in first, redirect them
    if (isPublicTarget && !hasPassedSystemCheck) {
        return next({ name: 'SystemCheck' })
    }

    next() // Always call next() to let approved paths load
})

export default router;

function requireAuth(to, from, next) {
    // 1. Check if user is logged in
    if (!auth.loggedIn()) {
        auth.logout();

        // Use path: '/home' to ensure query params attach correctly
        return next({ 
            path: '/home', 
            query: { redirect: to.fullPath } 
        });
    }

    // 2. Check for expired account
    if (companyAccount.isExpiredAccount() && to.fullPath !== '/') {
        return next({ path: '/notauthorized' });
    }

    // 3. Validate access rights (UI Security)
    if (store.state.user_apps_list) {
        if (!hasAccessToPage(to)) {
            return next({ path: '/notauthorized' });
        }
    }

    // 4. Success: User is authorized
    // Reset login timers
    store.commit('setLoginStartTime', Date());
    store.commit('setLoginTimer', Date());

    next(); // Final single call to proceed
}

//UI security - check if the to path exist in the apps access list
function hasAccessToPage_old(toPath) {
    //bypass for these pages
    if (toPath.fullPath=='/') return true //dashboard
    if (toPath.fullPath=='/mysettings') return true 
    if (toPath.fullPath=='/notifications') return true 
    if (toPath.fullPath=='/myprofile') return true 
    if (toPath.fullPath=='/features') return true 

    //check from accessrights list
    var found = false 
    store.state.user_apps_list.forEach(item => {
        item.appPages.forEach(page => {
            if ((page.pagePath.startsWith(toPath.fullPath) || toPath.fullPath.startsWith(page.pagePath))  
                && page.accessRights.view) {
            found = true
            }
        })
    })
    return found
}
function hasAccessToPage(toPath) {
    const targetPath = toPath.fullPath;

    // 1. Bypass public pages
    const publicPages = ['/', '/mysettings', '/notifications', '/myprofile', '/features'];
    if (publicPages.includes(targetPath)) return true;

    // 2. Check user access rights
    const appsList = store.state.user_apps_list || [];
    
    return appsList.some(item => 
        item.appPages.some(page => {
            const isPathMatch = page.pagePath.startsWith(targetPath) || targetPath.startsWith(page.pagePath);
            return isPathMatch && page.accessRights && page.accessRights.view;
        })
    );
}

